import { render, staticRenderFns } from "./callList.vue?vue&type=template&id=05d0e1b5&scoped=true&"
import script from "./callList.vue?vue&type=script&lang=js&"
export * from "./callList.vue?vue&type=script&lang=js&"
import style0 from "./callList.vue?vue&type=style&index=0&id=05d0e1b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d0e1b5",
  null
  
)

export default component.exports